import { FC } from 'react';
import { DialogsPage } from '@/pages/dialogs';
import { DialogListSection } from '@/pages/dialogs/dialogsListSection/DialogListSection';

/** Страница диалогов с DataGrid-списком */
export const DialogsBetaPage: FC = () => <DialogsPage listSection={DialogListSection} />;
